import { render, staticRenderFns } from "./stepsPlan.vue?vue&type=template&id=0ef31d31"
import script from "./stepsPlan.vue?vue&type=script&lang=js"
export * from "./stepsPlan.vue?vue&type=script&lang=js"
import style0 from "./stepsPlan.vue?vue&type=style&index=0&id=0ef31d31&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports